import React, { PropsWithChildren, useContext } from 'react';

import { PromotionsApiFetchers } from './types';

const Context = React.createContext<PromotionsApiFetchers | null>(null);

export const PromotionsApiFetchersProvider = ({
  value,
  children,
}: PropsWithChildren<{ value: PromotionsApiFetchers }>) => (
  <Context.Provider value={value}>{children}</Context.Provider>
);

export const usePromotionsApiFetcher = (): PromotionsApiFetchers => {
  const fetchers = useContext(Context);
  if (!fetchers) {
    throw new Error(
      `[PromotionsApiFetchersProvider] Could not find api context provider.
      Please <PromotionsApiFetchersProvider> in the component ancestry.`,
    );
  }
  return fetchers;
};
